import { render, staticRenderFns } from "./ConfirmEmailSentDialog.vue?vue&type=template&id=77b1b3fa&scoped=true"
import script from "./ConfirmEmailSentDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailSentDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmEmailSentDialog.vue?vue&type=style&index=0&id=77b1b3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1b3fa",
  null
  
)

export default component.exports